import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import {
  LengthInput,
  checkNumeric,
  formatNumber,
  randInt,
  renderFractionUserAnswer,
} from "./PyramidVolumeCommon";

export function generateTask() {
  const baseArea = 3 * randInt(8, 30);
  const h = randInt(4, 16);
  const volume = (baseArea * h) / 3;
  return {
    type: "PyramidHeightFromVolumeTask",
    data: { baseArea, h, volume },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>Dany jest ostrosłup o objętości i polu podstawy:</p>
      <BlockMath
        math={`V=${formatNumber(data.volume)}\\,\\text{cm}^3,\\quad P_p=${data.baseArea}\\,\\text{cm}^2`}
      />
      <p>Oblicz wysokość tego ostrosłupa.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <LengthInput value={userAnswer} onChange={onChange} disabled={disabled} label="H" />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkNumeric(userAnswer, data.h);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`H=${data.h}\\,\\text{cm}`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderFractionUserAnswer(userAnswer, "H", String.raw`\text{cm}`);
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Zaczynamy od wzoru na objętość ostrosłupa.
      </p>
      <BlockMath math={"V=\\frac{1}{3}P_p\\cdot H"} />
      <p>
        <strong>Krok 2:</strong> Przekształcamy wzór tak, aby obliczyć wysokość.
      </p>
      <BlockMath math={"H=\\frac{3V}{P_p}"} />
      <BlockMath
        math={`H=\\frac{3\\cdot ${formatNumber(data.volume)}}{${data.baseArea}}=${data.h}\\,\\text{cm}`}
      />
    </div>
  );
}
